(function () {
  "use strict";

  var ENDPOINT = "/apps/bewertungspilot";
  var english = /^en(?:-|$)/i.test(document.documentElement.lang || "de");
  function copy(de, en) { return english ? en : de; }
  var loadError = copy("Die Bewertungen sind gerade nicht erreichbar. Bitte versuche es erneut.", "Reviews are temporarily unavailable. Please try again.");
  var submitError = copy("Die Übertragung konnte nicht bestätigt werden. Deine Eingaben bleiben erhalten. Bitte versuche es später erneut.", "We could not confirm your submission. Your entries have been kept. Please try again later.");

  function create(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = String(text);
    return node;
  }

  function formatRating(value) {
    return Number(value).toLocaleString(english ? "en-GB" : "de-DE", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });
  }

  function starDisplay(value, className) {
    var rating = Number(value) || 0;
    var rounded = Math.max(0, Math.min(5, Math.round(rating)));
    var node = create("span", className || "review-pilot__stars");
    node.setAttribute("role", "img");
    node.setAttribute("aria-label", formatRating(rating) + copy(" von 5 Sternen", " out of 5 stars"));
    var glyphs = create("span", "", "★".repeat(rounded) + "☆".repeat(5 - rounded));
    glyphs.setAttribute("aria-hidden", "true");
    node.appendChild(glyphs);
    return node;
  }

  async function fetchJson(url, options) {
    var writing = options && options.method === "POST";
    var fallback = writing ? submitError : loadError;
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, writing ? 45000 : 15000);
    try {
      var response = await fetch(url, Object.assign({ headers: { Accept: "application/json" } }, options, { signal: controller.signal }));
      var payload;
      try { payload = await response.json(); } catch { throw new Error(fallback); }
      if (!response.ok || !payload || payload.ok !== true) {
        // Only expected, structured validation errors may reach customers, never raw HTML/JSON parser failures.
        var validation = [400, 403, 409, 413, 429].includes(response.status);
        var explanation = !english && validation && payload && typeof payload.error === "string" && payload.error.length <= 400 ? payload.error : fallback;
        if (response.status === 429) explanation = copy("Bitte warte einen Moment, bevor du eine weitere Bewertung sendest.", "Please wait a moment before submitting another review.");
        throw new Error(explanation);
      }
      return payload;
    } catch (error) {
      if (error.name === "AbortError" || error instanceof TypeError) throw new Error(fallback);
      throw error;
    } finally {
      window.clearTimeout(timer);
    }
  }

  function reviewCard(review) {
    var card = create("article", "review-pilot-card");
    var photos = Array.isArray(review.photos) ? review.photos : [];
    var gallery = create("div", "review-pilot-card__photos");
    photos.forEach(function (photo, index) {
      if (!/^\/apps\/bewertungspilot\?view=photo&id=[a-z0-9]{15,40}$/.test(photo.url || "")) return;
      var link = create("a", "review-pilot-card__photo");
      link.href = photo.url;
      link.target = "_blank";
      link.rel = "noopener";
      link.setAttribute("aria-label", copy("Kundenfoto vergrößern: ", "Enlarge customer photo: ") + (review.productTitle || "") + " · " + (index + 1));
      var img = create("img");
      img.src = photo.url;
      img.alt = copy("Kundenfoto von ", "Customer photo by ") + review.reviewerName + (review.productTitle ? " · " + review.productTitle : "");
      img.width = Number(photo.width) || 800;
      img.height = Number(photo.height) || 800;
      img.loading = "lazy";
      img.addEventListener("error", function () { link.remove(); if (!gallery.children.length) gallery.remove(); }, { once: true });
      link.appendChild(img);
      gallery.appendChild(link);
    });
    if (gallery.children.length) card.appendChild(gallery);
    card.appendChild(starDisplay(review.rating));
    if (review.title) card.appendChild(create("h3", "review-pilot-card__title", review.title));
    card.appendChild(create("p", "review-pilot-card__body", review.body || copy("Bewertung ohne Kommentar", "Rating without a comment")));
    card.appendChild(create("p", "review-pilot-card__author", copy("Von ", "By ") + review.reviewerName));

    if (review.productTitle) {
      var productNote = create("p", "review-pilot-card__product", copy("Bewertet: ", "Reviewed: "));
      var productLabel = create(/^\/products\/[a-z0-9-]+$/.test(review.productUrl || "") ? "a" : "span", "", review.productTitle);
      if (productLabel.tagName === "A") productLabel.href = review.productUrl;
      productNote.appendChild(productLabel);
      card.appendChild(productNote);
    }
    if (review.submittedAt && Number.isFinite(Date.parse(review.submittedAt))) {
      var date = create("time", "review-pilot-card__date", new Date(review.submittedAt).toLocaleDateString(english ? "en-GB" : "de-DE"));
      date.dateTime = new Date(review.submittedAt).toISOString();
      card.appendChild(date);
    }
    if (review.verifiedPurchase) {
      card.appendChild(create("span", "review-pilot-card__verified", copy("Verifizierter Kauf", "Verified purchase")));
    }
    if (review.source === "GOOGLE") {
      card.appendChild(create("p", "review-pilot-card__source", copy("Quelle: Google", "Source: Google")));
    } else if (review.sourceLabel) {
      var source = create("p", "review-pilot-card__source");
      source.appendChild(document.createTextNode(copy("Quelle: ", "Source: ")));
      if (review.sourceUrl) {
        var sourceLink = create("a", "", review.sourceLabel);
        sourceLink.href = review.sourceUrl;
        sourceLink.target = "_blank";
        sourceLink.rel = "noopener noreferrer";
        source.appendChild(sourceLink);
      } else {
        source.appendChild(document.createTextNode(review.sourceLabel));
      }
      card.appendChild(source);
    }
    if (review.merchantReply) {
      var reply = create("div", "review-pilot-card__reply");
      reply.appendChild(create("strong", "", copy("Antwort des Shops", "Shop reply")));
      reply.appendChild(create("p", "", review.merchantReply));
      card.appendChild(reply);
    }
    return card;
  }

  function formField(labelText, name, type, options) {
    var label = create("label", options && options.wide ? "review-pilot-form__wide" : "");
    label.appendChild(document.createTextNode(labelText));
    var control;
    if (type === "textarea") {
      control = document.createElement("textarea");
    } else if (type === "select") {
      control = document.createElement("select");
      var placeholder = create("option", "", copy("Sterne wählen", "Choose a rating"));
      placeholder.value = "";
      control.appendChild(placeholder);
      for (var rating = 5; rating >= 1; rating -= 1) {
        var option = create("option", "", rating + (rating === 1 ? copy(" Stern", " star") : copy(" Sterne", " stars")));
        option.value = String(rating);
        control.appendChild(option);
      }
    } else {
      control = document.createElement("input");
      control.type = type;
    }
    control.name = name;
    if (!options || options.required !== false) control.required = true;
    if (options && options.maxLength) control.maxLength = options.maxLength;
    if (options && options.autocomplete) control.autocomplete = options.autocomplete;
    label.appendChild(control);
    return label;
  }

  function appendReviewForm(root, settings) {
    var disclosure = create("details", "review-pilot-form-disclosure");
    disclosure.appendChild(create("summary", "button button--secondary", copy("Eigene Bewertung schreiben", "Write a review")));
    disclosure.appendChild(create(
      "p",
      "review-pilot-form__note",
      copy("Teile deine ehrliche Erfahrung – positiv oder kritisch. Deine Bewertung wird vor der Veröffentlichung geprüft.", "Share your honest experience, positive or critical. Your review is checked before publication."),
    ));

    var form = create("form", "review-pilot-form");
    form.appendChild(formField(copy("Sterne", "Rating"), "rating", "select"));
    form.appendChild(formField(copy("Dein Anzeigename", "Your public name"), "reviewerName", "text", {
      maxLength: 80,
      autocomplete: "name",
    }));
    form.appendChild(formField(copy("Titel (optional)", "Title (optional)"), "title", "text", {
      required: false,
      maxLength: 120,
    }));
    form.appendChild(formField(copy("E-Mail (optional, nicht öffentlich)", "Email (optional, not public)"), "email", "email", {
      required: false,
      maxLength: 254,
      autocomplete: "email",
    }));
    form.appendChild(formField(copy("Deine Bewertung", "Your review"), "body", "textarea", {
      wide: true,
      maxLength: 2000,
    }));

    var selectedPhotos = [];
    var previewUrls = [];
    var photoConsent;
    var photoError;
    var photoPreviews;
    function clearPhotoPreviews() {
      previewUrls.forEach(function (url) { URL.revokeObjectURL(url); });
      previewUrls = [];
    }
    function renderPhotoPreviews() {
      clearPhotoPreviews();
      photoPreviews.replaceChildren();
      photoConsent.hidden = !selectedPhotos.length;
      photoConsent.querySelector("input").disabled = !selectedPhotos.length;
      photoConsent.querySelector("input").required = !!selectedPhotos.length;
      selectedPhotos.forEach(function (file, index) {
        var item = create("div", "review-pilot-form__preview");
        var img = create("img");
        img.src = URL.createObjectURL(file);
        previewUrls.push(img.src);
        img.alt = copy("Vorschau: ", "Preview: ") + file.name;
        img.width = 120; img.height = 120;
        item.appendChild(img);
        var remove = create("button", "button button--secondary", copy("Foto entfernen", "Remove photo"));
        remove.type = "button";
        remove.setAttribute("aria-label", copy("Foto entfernen: ", "Remove photo: ") + file.name);
        remove.addEventListener("click", function () { selectedPhotos.splice(index, 1); renderPhotoPreviews(); });
        item.appendChild(remove);
        photoPreviews.appendChild(item);
      });
    }
    if (settings.photoUpload) {
      var photoField = formField(copy("Deine Fotos (optional)", "Your photos (optional)"), "photos", "file", { required: false, wide: true });
      var photoInput = photoField.querySelector("input");
      photoInput.accept = "image/jpeg,image/png,image/webp";
      photoInput.multiple = true;
      var hint = create("span", "review-pilot-form__note", copy("Bis zu 3 eigene Fotos · JPG, PNG oder WebP · je höchstens 5 MB. Zeig uns dein Produkt bei dir zu Hause. Bitte ohne fremde Personen oder private Angaben im Bild.", "Up to 3 of your own photos · JPG, PNG or WebP · maximum 5 MB each. Show your product at home, without other people or private details."));
      photoField.appendChild(hint);
      photoError = create("p", "review-pilot-form__photo-error");
      photoError.setAttribute("role", "alert");
      photoField.appendChild(photoError);
      photoPreviews = create("div", "review-pilot-form__previews review-pilot-form__wide");
      photoConsent = create("label", "review-pilot-form__consent");
      var photoCheck = create("input");
      photoCheck.type = "checkbox"; photoCheck.name = "photoConsent"; photoCheck.disabled = true;
      photoConsent.appendChild(photoCheck);
      photoConsent.appendChild(document.createTextNode(copy("Das sind meine eigenen Fotos. Sie dürfen zusammen mit meiner Bewertung auch bei anderen Motiven derselben Produktart im Shop erscheinen.", "These are my own photos. They may appear with my review on other designs of the same product type in this shop.")));
      photoConsent.hidden = true;
      photoInput.addEventListener("change", function () {
        var files = Array.from(photoInput.files || []);
        var invalid = files.some(function (file) { return !["image/jpeg", "image/png", "image/webp"].includes(file.type) || file.size > 5242880 || !file.size; });
        if (invalid || selectedPhotos.length + files.length > 3) {
          photoError.textContent = copy("Bitte wähle insgesamt höchstens 3 Fotos als JPG, PNG oder WebP mit jeweils bis zu 5 MB.", "Choose up to 3 JPG, PNG or WebP photos, maximum 5 MB each.");
        } else { selectedPhotos = selectedPhotos.concat(files); photoError.textContent = ""; renderPhotoPreviews(); }
        photoInput.value = "";
      });
      form.appendChild(photoField); form.appendChild(photoPreviews); form.appendChild(photoConsent);
    }

    var honeypot = formField("Website", "website", "text", { required: false });
    honeypot.className = "review-pilot-form__honeypot";
    honeypot.setAttribute("aria-hidden", "true");
    honeypot.querySelector("input").tabIndex = -1;
    form.appendChild(honeypot);

    var consent = create("label", "review-pilot-form__consent");
    var checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.name = "publicationConsent";
    checkbox.required = true;
    consent.appendChild(checkbox);
    consent.appendChild(document.createTextNode(
      copy("Ich bestätige, dass meine Bewertung veröffentlicht werden darf und auf einer echten Erfahrung beruht.", "I confirm that my review may be published and is based on a genuine experience."),
    ));
    form.appendChild(consent);

    if (settings.privacyUrl) {
      var privacy = create("p", "review-pilot-form__privacy", copy("Wie wir deine Angaben verarbeiten, steht in unseren ", "Find out how we process your information in our "));
      var privacyLink = create("a", "", copy("Datenschutzhinweisen", "privacy policy"));
      privacyLink.href = settings.privacyUrl;
      privacy.appendChild(privacyLink);
      privacy.appendChild(document.createTextNode("."));
      form.appendChild(privacy);
    }

    var submit = create("button", "button", copy("Bewertung absenden", "Submit review"));
    submit.type = "submit";
    form.appendChild(submit);
    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;
      if (form.dataset.submitting === "true") return;
      form.dataset.submitting = "true";
      submit.disabled = true;
      submit.setAttribute("aria-busy", "true");
      settings.message.textContent = copy("Bewertung wird gespeichert …", "Submitting your review …");

      var formData = new FormData(form);
      formData.delete("photos");
      var data = Object.fromEntries(formData.entries());
      data.productId = settings.productId || null;
      data.productTitle = settings.productTitle || null;
      data.publicationConsent = checkbox.checked;
      try {
        var requestOptions = { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(data) };
        if (selectedPhotos.length) {
          formData.set("productId", data.productId || ""); formData.set("productTitle", data.productTitle || "");
          selectedPhotos.forEach(function (file) { formData.append("photos", file); });
          requestOptions = { method: "POST", headers: { Accept: "application/json" }, body: formData };
        }
        await fetchJson(settings.endpoint, requestOptions);
        form.reset();
        selectedPhotos = []; clearPhotoPreviews();
        if (photoPreviews) renderPhotoPreviews();
        disclosure.open = false;
        settings.message.textContent = copy("Danke! Deine Bewertung wurde übermittelt und wird vor der Veröffentlichung geprüft.", "Thank you! Your review has been submitted and will be checked before publication.");
        disclosure.querySelector("summary").focus();
      } catch (error) {
        settings.message.textContent = error instanceof Error ? error.message : submitError;
      } finally {
        delete form.dataset.submitting;
        submit.disabled = false;
        submit.removeAttribute("aria-busy");
      }
    });

    disclosure.appendChild(form);
    root.appendChild(disclosure);
  }

  async function mountReviewSection(root) {
    var scope = root.dataset.scope === "product" ? "product" : "shop";
    var productId = root.dataset.productId || "";
    var endpoint = root.dataset.endpoint || ENDPOINT;
    var params = new URLSearchParams({
      scope: scope,
      limit: root.dataset.limit || (scope === "product" ? "6" : "3"),
    });
    if (scope === "product" && productId) {
      params.set("productId", productId);
      if (root.dataset.includeFamily !== "false") params.set("includeFamily", "true");
    }

    var summary = root.querySelector("[data-bp-theme-summary]");
    var list = root.querySelector("[data-bp-theme-list]");
    var action = root.querySelector("[data-bp-theme-action]");
    var message = root.querySelector("[data-bp-theme-message]");
    var hideWhenEmpty = root.dataset.hideWhenEmpty === "true";
    var settings = {
      endpoint: endpoint,
      productId: productId,
      productTitle: root.dataset.productTitle || "",
      privacyUrl: root.dataset.privacyUrl || "",
      message: message,
    };

    var toolbar = create("div", "review-pilot__filters");
    list.before(toolbar);
    var pagination = create("div", "review-pilot__pagination");
    list.after(pagination);
    async function refresh(append) {
      var payload = await fetchJson(endpoint + "?" + params.toString());
      if (!Array.isArray(payload.reviews) || !Number.isFinite(payload.total) || payload.total < 0) throw new Error(loadError);
      var shouldHide = !payload.total && hideWhenEmpty && !(window.Shopify && window.Shopify.designMode);
      root.hidden = shouldHide;
      if (shouldHide) return;

      if (!append) list.replaceChildren();
      if (payload.family && scope === "product") {
        root.querySelector("h2").textContent = copy("Erfahrungen mit unseren ", "Reviews of our ") + (english ? ({ acryllicht: "acrylic lights", geldhalter: "money holders" }[payload.family.key] || payload.family.label) : ({ acryllicht: "Acryllichtern", geldhalter: "Geldhaltern" }[payload.family.key] || payload.family.label));
        var intro = root.querySelector(".review-pilot__intro");
        if (intro) intro.textContent = copy("Hier findest du Bewertungen zu verschiedenen Motiven dieser Produktart. Beim Beitrag steht, welches Modell bewertet wurde.", "Reviews of different designs of this product type. Each review names the model that was reviewed.");
      }
      toolbar.replaceChildren();
      if (payload.photoTotal > 0) {
        var filter = create("button", "button button--secondary", copy("Nur mit Kundenfotos", "With customer photos only") + " (" + payload.photoTotal + ")");
        filter.type = "button";
        filter.setAttribute("aria-pressed", String(params.get("withPhotos") === "true"));
        filter.addEventListener("click", async function () {
          if (params.get("withPhotos") === "true") params.delete("withPhotos"); else params.set("withPhotos", "true");
          params.delete("offset"); filter.disabled = true;
          try { await refresh(false); toolbar.querySelector("button")?.focus(); } catch { message.textContent = loadError; filter.disabled = false; }
        });
        toolbar.appendChild(filter);
      }
      pagination.replaceChildren();
      if (Number.isInteger(payload.nextOffset)) {
        var more = create("button", "button button--secondary", copy("Weitere Bewertungen anzeigen", "Show more reviews")); more.type = "button";
        more.addEventListener("click", async function () {
          params.set("offset", String(payload.nextOffset)); more.disabled = true;
          var previousCount = list.children.length;
          try { await refresh(true); var next = list.children[previousCount]; if (next) { next.tabIndex = -1; next.focus(); } } catch { message.textContent = loadError; more.disabled = false; }
        });
        pagination.appendChild(more);
      }
      if (payload.total) {
        summary.replaceChildren(starDisplay(payload.average));
        summary.appendChild(document.createTextNode(
          " " + formatRating(payload.average) + copy(" von 5 · ", " out of 5 · ") + payload.total +
          (payload.total === 1 ? copy(" Bewertung", " review") : copy(" Bewertungen", " reviews")),
        ));
        if (params.get("withPhotos") === "true") summary.appendChild(document.createTextNode(copy(" · mit Kundenfotos", " · with customer photos")));
        payload.reviews.forEach(function (review) {
          list.appendChild(reviewCard(review));
        });
      } else {
        summary.textContent = payload.family ? copy("Noch keine Bewertungen zu dieser Produktart", "No reviews of this product type yet") : scope === "product" ? copy("Noch keine Bewertungen zu diesem Produkt", "No reviews for this product yet") : copy("Noch keine Bewertungen", "No reviews yet");
      }

      if (action.children.length) return;
      settings.photoUpload = !!(payload.capabilities && payload.capabilities.photoUpload && scope === "product");
      if (payload.mode === "GOOGLE" && scope === "shop" && payload.googleReviewUrl) {
        var googleLink = create("a", "button", copy("Bei Google bewerten", "Review on Google"));
        googleLink.href = payload.googleReviewUrl;
        googleLink.target = "_blank";
        googleLink.rel = "noopener noreferrer";
        action.appendChild(googleLink);
      } else if (payload.canSubmit && root.dataset.showForm === "true") {
        appendReviewForm(action, settings);
      }
    }

    async function load() {
      summary.textContent = copy("Bewertungen werden geladen …", "Loading reviews …");
      message.textContent = "";
      action.replaceChildren();
      try {
        await refresh();
      } catch {
        if (hideWhenEmpty && !(window.Shopify && window.Shopify.designMode)) {
          root.hidden = true;
          return;
        }
        root.hidden = false;
        summary.textContent = copy("Kurzzeitig nicht verfügbar", "Temporarily unavailable");
        message.textContent = loadError;
        var retry = create("button", "button button--secondary", copy("Erneut laden", "Try again"));
        retry.type = "button";
        retry.addEventListener("click", load, { once: true });
        action.appendChild(retry);
      }
    }
    await load();
  }

  async function loadSummaryBatch(nodes) {
    var ids = [...new Set(nodes.map(function (node) { return node.dataset.productId; }).filter(Boolean))];
    for (var offset = 0; offset < ids.length; offset += 50) {
      var batch = ids.slice(offset, offset + 50);
      try {
        var params = new URLSearchParams({ view: "summaries", productIds: batch.join(",") });
        var payload = await fetchJson(ENDPOINT + "?" + params.toString());
        nodes.forEach(function (node) {
          if (!batch.includes(node.dataset.productId)) return;
          var summary = payload.summaries[node.dataset.productId];
          if (!summary || !summary.total) return;
          var average = node.querySelector("[data-bp-rating-average]");
          var count = node.querySelector("[data-bp-rating-count]");
          if (average) average.textContent = formatRating(summary.average);
          if (count) count.textContent = "(" + summary.total + ")";
          var link = node.querySelector("a, .review-rating-summary__link");
          if (link) {
            link.setAttribute(
              "aria-label",
              copy("Bewertungen für ", "Reviews for ") + (node.dataset.productTitle || copy("dieses Produkt", "this product")) + ": " +
                formatRating(summary.average) + copy(" von 5 Sternen aus ", " out of 5 stars from ") + summary.total +
                (summary.total === 1 ? copy(" Bewertung", " review") : copy(" Bewertungen", " reviews")),
            );
          }
          node.hidden = false;
        });
      } catch {
        // Bewertungen sind eine progressive Ergänzung; Produktkarten bleiben funktionsfähig.
      }
    }
  }

  function initialize(scope) {
    var parent = scope && scope.querySelectorAll ? scope : document;
    var roots = Array.from(parent.querySelectorAll("[data-bp-theme-section]"));
    if (parent.matches && parent.matches("[data-bp-theme-section]")) roots.unshift(parent);
    roots.forEach(function (root) {
      if (root.dataset.bpMounted === "true") return;
      root.dataset.bpMounted = "true";
      mountReviewSection(root);
    });
    var summaries = Array.from(parent.querySelectorAll("[data-bp-rating-summary]"));
    var pending = summaries.filter(function (node) { return node.dataset.bpMounted !== "true"; });
    pending.forEach(function (node) { node.dataset.bpMounted = "true"; });
    if (pending.length) loadSummaryBatch(pending);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener("shopify:section:load", function (event) { initialize(event.target); });
})();
